export default __webpack_public_path__ + "static/media/stripe-connect.92f5f7ae.svg";